import { _ } from "../../core/polyglot/polyglot.js";
import { formatAsShortDate } from "../../core/helpers/date-formatting-util.js";
import { getCSSVariable } from "../../core/helpers/css-util.js";
import { Widget } from "@foretagsplatsen/widgetjs";
import ChartWidget from "../../core/widgets/ChartWidget/ChartWidget.js";
import StackedBarplotChartStrategy from "../../core/widgets/ChartWidget/StackedBarplotChartStrategy.js";

/**
 * Widget for the company chart.
 * Displays company balances as bar diagrams with
 * one stacked bar for assets: current and fixed
 * and one bstacked bar for equities: liabilities and owner's part.
 *
 * @param {Date[]} dates - Company balance dates
 * @param {number[]} currentAssets - Current assets KPI values
 * @param {number[]} fixedAssets - Fixed assets KPI values
 * @param {number[]} totalLiability - Total Liability KPI values
 * @param {number[]} ownersPart - Owners part KPI values
 * @param {number} [yAxisMax] - Max for ordinate scale, used to render
 *  graphs comparable
 */
export default class CompanyBalanceChartWidget extends Widget {
	constructor({
		dates,
		currentAssets,
		fixedAssets,
		totalLiability,
		ownersPart,
		yAxisMax,
	}) {
		super(...arguments);

		this._chartWidget = this._makeChartWithValues({
			dates,
			currentAssets,
			fixedAssets,
			totalLiability,
			ownersPart,
			yAxisMax,
		});
	}

	renderContentOn(html) {
		html.render(this._chartWidget);
	}

	_makeChartWithValues({
		dates,
		currentAssets,
		fixedAssets,
		totalLiability,
		ownersPart,
		yAxisMax,
	}) {
		return new ChartWidget({
			chartStrategy: new StackedBarplotChartStrategy({
				yAxisMax,
				labels: dates.map((date) => formatAsShortDate(date)),
			}),
			values: [
				{
					label: _("Current assets"),
					fillColor: getCSSVariable("--kpi-income-color"),
					data: currentAssets,
					stack: "Stack 0",
				},
				{
					label: _("Fixed assets"),
					fillColor: getCSSVariable("--kpi-appropriations-color"),
					data: fixedAssets,
					stack: "Stack 0",
				},
				{
					label: _("Liabilities"),
					fillColor: getCSSVariable("--kpi-liabilities-color"),
					data: totalLiability.map((value) => -value),
					stack: "Stack 1",
				},
				{
					label: _("Owner's part"),
					fillColor: getCSSVariable("--kpi-owner-part-color"),
					data: ownersPart.map((value) => -value),
					stack: "Stack 1",
				},
			],
		});
	}
}
